var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFlame(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 18,
    viewBox: "0 0 14 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.616 7.4C8.616 7.4 9.316 3.286 6.461 1.5C6.41842 2.20687 6.22719 2.8968 5.89979 3.52472C5.57239 4.15263 5.11619 4.70441 4.561 5.144C3.341 6.216 1.049 8.622 1.073 11.194C1.06466 12.2922 1.3633 13.3708 1.93525 14.3084C2.50719 15.2459 3.3297 16.005 4.31 16.5C4.37943 15.3898 4.85499 14.344 5.646 13.562C6.34168 12.8688 6.77593 11.9561 6.875 10.979C8.803 11.858 9.693 15.064 9.693 16.445V16.457C10.6168 16.0322 11.4053 15.3603 11.9712 14.5155C12.5372 13.6708 12.8586 12.686 12.9 11.67C12.9623 9.58499 12.2614 7.54893 10.929 5.944",
    stroke: "#0085FF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlame);
export default __webpack_public_path__ + "static/media/flame.e8d5feaf4a1581eb7b10f4098a0a9727.svg";
export { ForwardRef as ReactComponent };